import React, { useState, useEffect } from 'react';
import { useDispatch } from "react-redux";
import DataGrid, {
    Column,
    FilterRow,
    ColumnChooser,
    Paging,
    Pager, Selection, Scrolling
} from 'devextreme-react/data-grid';
import { Popup } from 'devextreme-react/popup';
import Request from "../../components/api/Request";
import { Button } from 'devextreme-react/button';
import TextBox from 'devextreme-react/text-box';
import CustomStore from "devextreme/data/custom_store";
import * as Utils from "../../utils/Utils";
import TreeView from 'devextreme-react/tree-view';
import DropDownBox from 'devextreme-react/drop-down-box';
import * as AppActions from '../../actions/AppActions';
import SgkIslemEkleForm from './SgkIslemEkleForm'
import { ProgressBar } from 'devextreme-react/progress-bar';
import { showToast, parseDate, showDialog, hasRole, parseApiDate } from "../../utils/Utils";
import './SgkIslemleri.scss';
import Box, {
    Item
} from 'devextreme-react/box';
import TagBox from 'devextreme-react/tag-box';
import DateBox from 'devextreme-react/date-box';

const SgkIslemleri = () => {

    const dispatch = useDispatch();
    const [formYetki, setFormYetki] = useState(
        {
            listele: Utils.hasRole("sgkIslemleri|sgkDonemIslemleri|listele"),
            sil: Utils.hasRole("sgkIslemleri|sgkDonemIslemleri|sil"),
            ekle: Utils.hasRole("sgkIslemleri|sgkDonemIslemleri|ekle"),
            tekrarCalis: Utils.hasRole("sgkIslemleri|sgkDonemIslemleri|tekrarCalis")
        });


    const listeBasligi = "Hesaplama İşlemleri";

    const [treeBoxValue, setTreeBoxValue] = useState([]);
    const [treeDataSource, setTreeDataSource] = useState([]);
    const [treeBoxDonemValue, setTreeBoxDonemValue] = useState([]);
    const [treeDataDonemSource, setTreeDataDonemSource] = useState([]);

    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);

    const [storeIslem, setStoreIslem] = useState([]);
    const [valueIslem, setValueIslem] = useState([]);

    const [storeIslemDurumu, setStoreIslemDurumu] = useState([]);
    const [valueIslemDurumu, setValueIslemDurumu] = useState([]);

    const [store, setStore] = useState(null);
    const [filterMap, setFilterMap] = useState(null);

    const [sgkIslemEklePopupForm, setSgkIslemEklePopupForm] = useState({ popupState: false });

    useEffect(() => {
        let year = new Date().getFullYear();
        let month = new Date().getMonth();// + 1;
        let day = new Date().getDate();
        var startDate = new Date(year, month, day);
        day = 1;
        var endDate = new Date(year, month, day);
        endDate.setMonth(endDate.getMonth() + 1);

        setStartDate(startDate);
        setEndDate(endDate);

        setFilterMap(Utils.getFilterMap(dataGrid));

    }, [])

    useEffect(() => {
        if (filterMap) {
            domainListYukle();
            donemListYukle();
            setStoreIslem(islemTuruListYukle());
            setStoreIslemDurumu(islemDurumuListYukle());
            setStore(getStore());
        }
    }, [filterMap])

    let dataGrid = null;
    let treeView = null;
    let treeViewDonem = null;

    const getStore = () => {
        let tempGrid = dataGrid;

        return new CustomStore({
            key: 'id',
            useDefaultSearch: false,
            load: function (loadOptions) {
                console.log("loadOptions", loadOptions);
                if (loadOptions.searchOperation == undefined) {
                    return;
                }

                let filterArr = [];
                if (treeBoxValue.length > 0) {
                    filterArr.push({
                        property: "domain.id",
                        operator: "IN",
                        value: treeBoxValue,
                        type: "Long"
                    })
                }
                if (treeBoxDonemValue.length > 0) {
                    filterArr.push({
                        property: "donem.id",
                        operator: "IN",
                        value: treeBoxDonemValue,
                        type: "Long"
                    })
                }
                if (valueIslem.length > 0) {
                    filterArr.push({
                        property: "tesvikIslemTuru.id",
                        operator: "IN",
                        value: valueIslem,
                        type: "Long"
                    })
                }
                if (startDate != null) {
                    filterArr.push({
                        property: "baslatmaTarihi",
                        operator: ">=",
                        value: parseApiDate(startDate),
                        type: "date"
                    })
                }
                if (endDate != null) {
                    filterArr.push({
                        property: "baslatmaTarihi",
                        operator: "<",
                        value: parseApiDate(endDate),
                        type: "date"
                    })
                }

                if (valueIslemDurumu != null && valueIslemDurumu.length > 0) {
                    filterArr.push({
                        property: "durum",
                        operator: "IN",
                        value: valueIslemDurumu,
                        type: "int"
                    })
                }


                let params = Utils.getGridLoadOptionsParams(loadOptions, filterMap, filterArr);


                if (tempGrid != null && tempGrid.instance != null) {
                    tempGrid.instance.clearSelection();
                }

                const request = new Request("/tesvikIslem/getKayitList" + params, "GET");

                return request.run()
                    .then(response => {
                        if (response.data) {

                            response.data.data.map(d => {
                                d.baslatmaTarihi = parseDate(d.baslatmaTarihi);
                                d.baslangicTarihi = parseDate(d.baslangicTarihi);
                                d.bitisTarihi = parseDate(d.bitisTarihi);
                            });

                            return {
                                data: response.data.data,
                                totalCount: response.data.total,
                                summary: 0,
                                groupCount: 0
                            };
                        } else {
                            return []

                        }
                    });
            }
        });
    }


    const domainListYukle = () => {

        const request = new Request("/userDomain/getUserDomainList", "GET");

        request.run()
            .then(response => {
                if (response.data) {
                    setTreeDataSource(response.data.data);
                } else {
                    return []

                }
            });
    }

    const donemListYukle = () => {

        const request = new Request("/donem/getKayitList", "GET");

        request.run()
            .then(response => {
                if (response.data) {
                    response.data.data.map(d => {
                        d.tarih = parseDate(d.tarih);
                    });
                    let datas = [];
                    let simdi = new Date();
                    response.data.data.map(d => {
                        if (d.tarih.getTime() < simdi.getTime()) {
                            datas.push(d);
                        }
                    });
                    // datas.sort((a,b) =>
                    //     a.tarih.getTime() - b.tarih.getTime()
                    // ).reverse();
                    // debugger;
                    let yils = [];
                    let yilDatas = [];
                    datas.map(d => {
                        let parentYil = parseInt(d.donem.substring(0, 4)) * -1;
                        d.parentid = parentYil;
                        if (yils.indexOf(parentYil) == -1) {
                            yils.push(parentYil);
                            let donemTmp = (parentYil * -1).toString();


                            yilDatas.push({ donem: donemTmp, id: parentYil, parentid: 0 });
                        }
                    });
                    yilDatas.map(d => {
                        datas.push(d);
                    });

                    setTreeDataDonemSource(datas);
                } else {
                    return []
                }
            });
    }

    const islemTuruListYukle = () => {

        return new CustomStore({
            loadMode: 'raw',
            key: 'id',
            load: function () {

                const request = new Request("/tesvikIslem/getTesvikIslemTuruList", "GET");

                return request.run()
                    .then(response => {

                        if (response.data) {
                            return response.data.data;
                        } else {
                            return []

                        }
                    });
            }
        });

    }

    const islemDurumuListYukle = () => {

        return new CustomStore({
            loadMode: 'raw',
            key: 'id',
            load: function () {

                return [
                    { id: 0, adi: 'Başlamadı' },
                    { id: 1, adi: 'Tamamlandı' },
                    { id: 2, adi: 'İşlem Devam Ediyor' },
                    { id: 3, adi: 'Hata Oluştu' },
                    { id: 4, adi: 'Kimlik Doğrulama Hatası' },
                ];
            }
        });

    }


    const syncTreeViewSelection = (e) => {
        let tree = (e.component.selectItem && e.component) || (treeView && treeView.instance);

        if (tree) {
            if (e.value === null) {
                tree.unselectAll();
            } else {
                let values = e.value || treeBoxValue;
                values && values.forEach(function (value) {
                    tree.selectItem(value);
                });
            }
        }

        if (e.value !== undefined) {
            if (e.value == null) {
                setTreeBoxValue([]);
            } else {
                setTreeBoxValue(e.value);
            }
        }
    }

    const treeView_itemSelectionChanged = (e) => {
        setTreeBoxValue(e.component.getSelectedNodeKeys());
    }

    const treeViewRender = () => {
        return (
            <TreeView dataSource={treeDataSource}
                ref={(ref) => treeView = ref}
                dataStructure="plain"
                keyExpr="id"
                key="id"
                parentIdExpr="parent.id"
                selectionMode="multiple"
                showCheckBoxesMode="normal"
                selectNodesRecursive={true}
                displayExpr="name"
                selectByClick={true}
                onContentReady={syncTreeViewSelection}
                onItemSelectionChanged={treeView_itemSelectionChanged}
                searchMode={'contains'}
                searchEnabled={true}
            />
        );
    }

    const syncTreeViewDonemSelection = (e) => {
        let tree = (e.component.selectItem && e.component) || (treeViewDonem && treeViewDonem.instance);

        if (tree) {
            if (e.value === null) {
                tree.unselectAll();
            } else {
                let values = e.value || treeBoxDonemValue;
                values && values.forEach(function (value) {
                    tree.selectItem(value);
                });
            }
        }

        if (e.value !== undefined) {
            if (e.value == null) {
                setTreeBoxDonemValue([]);
            } else {
                setTreeBoxDonemValue(e.value);
            }
        }
    }

    const treeViewDonem_itemSelectionChanged = (e) => {
        setTreeBoxDonemValue(e.component.getSelectedNodeKeys());
    }

    const treeViewDonemRender = () => {
        return (
            <TreeView dataSource={treeDataDonemSource}
                ref={(ref) => treeViewDonem = ref}
                dataStructure="plain"
                keyExpr="id"
                parentIdExpr="parentid"
                selectionMode="multiple"
                showCheckBoxesMode="normal"
                selectNodesRecursive={true}
                displayExpr="donem"
                selectByClick={true}
                onContentReady={syncTreeViewDonemSelection}
                onItemSelectionChanged={treeViewDonem_itemSelectionChanged}
            />
        );
    }

    const onStartDateValueChanged = (e) => {
        setStartDate(e.value);
    }
    const onEndDateValueChanged = (e) => {
        setEndDate(e.value);
    }

    function hideSgkIslemEklePopupForm() {
        setSgkIslemEklePopupForm({ popupState: false })
        yenile();
    }

    function openSgkIslemEklePopupForm() {
        setSgkIslemEklePopupForm({ popupState: true })
    }


    function islemGridRender() {
        return (
            <DataGrid
                dataSource={storeIslem}
                columns={['adi']}
                hoverStateEnabled={true}
                selectedRowKeys={valueIslem}
                onSelectionChanged={islemGrid_onSelectionChanged}>
                <Selection mode="multiple" />
                <Scrolling mode="virtual" />
                <Paging enabled={true} pageSize={10} />
                <FilterRow visible={true} />


            </DataGrid>
        );
    }

    function syncIslemGridSelection(e) {
        setValueIslem(e.value);
    }
    function islemGrid_onSelectionChanged(e) {
        setValueIslem(e.selectedRowKeys);
    }

    function islemDurumuGridRender() {
        return (
            <DataGrid
                dataSource={storeIslemDurumu}
                columns={['adi']}
                hoverStateEnabled={true}
                selectedRowKeys={valueIslemDurumu}
                onSelectionChanged={islemDurumuGrid_onSelectionChanged}>
                <Selection mode="multiple" />
                <Scrolling mode="virtual" />
                <Paging enabled={true} pageSize={10} />
                <FilterRow visible={true} />


            </DataGrid>
        );
    }

    function syncIslemDurumuGridSelection(e) {
        setValueIslemDurumu(e.value);
    }
    function islemDurumuGrid_onSelectionChanged(e) {
        setValueIslemDurumu(e.selectedRowKeys);
    }

    const yenile = () => {
        setStore(getStore());
    }

    function kayitSil(data) {

        let method = "POST"
        let url = "/tesvikIslem/deleteKayit";// + data.id;

        let tempGrid = dataGrid;
        let array = tempGrid.instance.getSelectedRowKeys();
        if (!array || array.length == 0) {
            array = [data.id];
        }

        const request = new Request(url, method, array);
        dispatch(AppActions.setLoading(true, "Silme işlemi yapılıyor.."));
        return request.run()
            .then(response => {
                dispatch(AppActions.setLoading(false, ""));
                if (response.data && response.data.success) {
                    yenile();
                }
            });
    }

    function tekrarCalis(data) {

        let tempGrid = dataGrid;
        let array = tempGrid.instance.getSelectedRowKeys();
        if (!array || array.length == 0) {
            array = [data.id];
        }

        let method = "POST"
        let url = "/tesvikIslem/refreshKayit";// + data.id;

        const request = new Request(url, method, array);
        dispatch(AppActions.setLoading(true, "Yenileme işlemi yapılıyor.."));
        return request.run()
            .then(response => {
                dispatch(AppActions.setLoading(false, ""));
                if (response.data && response.data.success) {
                    yenile();
                }
            });
    }
    function islemDurumuRender(data) {

        // if (data.data.durum == 3) {
        //     let mesaj = "Hata oluştu - " + data.data.islemDurumu + "%";
        //     return (<div style={{ backgroundColor: '#F6BB42' }}>{mesaj}</div>);
        // }
        return <ProgressBar
            id="progress-bar-status"
            //className={this.state.seconds == 0 ? 'complete' : '' }
            width="90%"
            min={0}
            max={100}
            statusFormat={islemDurumuRenderFormat}
            value={data.value}
        />

        //return <img src={data.value} />;
    }
    function islemDurumuRenderFormat(value) {
        return ` ${value * 100}%`;
    }

    function dataIslemDurumuRender(data) {

        // BASLAMADI(0, "BAŞLAMADI"),
        // TAMAMLANDI(1, "TAMAMLANDI"),
        // ISLEM_DEVAM_EDIYOR(2, "IŞLEM DEVAM EDİYOR"),
        // HATA_OLUSTU(3, "HATA OLUŞTU");

        // if (data.data.durum == 0) {
        //     return "Başlamadı";
        // } else if (data.data.durum == 1) {
        //     return "Tamamlandı";
        // }else if (data.data.durum == 2) {
        //     return "Devam Ediyor";
        // }else if (data.data.durum == 3) {
        //     return "Hata oluştu";
        // }

        // return "";


        if (data.data.durum == 0) {
            return (<div>Başlamadı</div>);
        } else if (data.data.durum == 1) {
            return (<div >Tamamlandı</div>);
        } else if (data.data.durum == 2) {
            return (<div >Devam Ediyor</div>);
        } else if (data.data.durum == 3) {
            return (<div style={{ backgroundColor: '#F6BB42' }}>Hata oluştu</div>);
        } else if (data.data.durum == 4) {
            return (<div style={{ backgroundColor: '#F6BB42' }}>Kimlik Doğrulama Hatası</div>);
        }




        return (<div></div>);
    }

    return (
        <React.Fragment>

            <h2 className={'dx-icon-product'}>{listeBasligi}</h2>
            <div className="dx-field">
                <div className="buttons" align={'left'} style={{ marginLeft: "10px" }}>
                    <Box direction="row" width={400} height={25}>
                        <Item ratio={1}>
                            <DateBox
                                //defaultValue={new Date()}
                                value={startDate}
                                type="datetime"
                                placeholder="İşlem Zamanını Seçiniz"
                                displayFormat="yyyy-MM-dd HH:mm:ss"
                                showClearButton={true}
                                useMaskBehavior={true}
                                onValueChanged={onStartDateValueChanged}
                            />
                        </Item>
                        <Item ratio={1}>
                            <DateBox
                                //defaultValue={new Date()}
                                value={endDate}
                                type="datetime"
                                placeholder="İşlem Zamanını Seçiniz"
                                displayFormat="yyyy-MM-dd HH:mm:ss"
                                showClearButton={true}
                                useMaskBehavior={true}
                                onValueChanged={onEndDateValueChanged}
                            />
                        </Item>

                    </Box>
                    <Box direction="row" width={400} height={25}>
                        <Item ratio={1}>
                            <DropDownBox
                                position="left"
                                value={treeBoxValue}
                                valueExpr="id"
                                displayExpr="name"
                                placeholder="Firma Seçiniz..."
                                showClearButton={true}
                                dataSource={treeDataSource}
                                onValueChanged={syncTreeViewSelection}
                                contentRender={treeViewRender}
                            />
                        </Item>
                    </Box>
                    <Box direction="row" width={400} height={25}>

                        <Item ratio={1}>
                            <DropDownBox
                                position="left"
                                value={treeBoxDonemValue}
                                valueExpr="id"
                                displayExpr="donem"
                                placeholder="Dönem Seçiniz..."
                                showClearButton={true}
                                dataSource={treeDataDonemSource}
                                onValueChanged={syncTreeViewDonemSelection}
                                contentRender={treeViewDonemRender}
                            />
                        </Item>

                    </Box>
                    <Box direction="row" width={400} height={25}>
                        <Item ratio={1}>
                            <DropDownBox
                                value={valueIslem}
                                valueExpr="id"
                                deferRendering={false}
                                displayExpr="adi"
                                placeholder="İşlem seçiniz..."
                                showClearButton={true}
                                dataSource={storeIslem}
                                onValueChanged={syncIslemGridSelection}
                                contentRender={islemGridRender}
                            />
                        </Item>
                    </Box>
                    <Box direction="row" width={400} height={25}>
                        <Item ratio={1}>
                            <DropDownBox
                                value={valueIslemDurumu}
                                valueExpr="id"
                                deferRendering={false}
                                displayExpr="adi"
                                placeholder="İşlem Durumu Seçiniz..."
                                showClearButton={true}
                                dataSource={storeIslemDurumu}
                                onValueChanged={syncIslemDurumuGridSelection}
                                contentRender={islemDurumuGridRender}
                            />
                        </Item>
                    </Box>

                    <Button icon="plus" width={150} text="Yenile" type={'success'} style={{ fontSize: "15px" }}
                        onClick={yenile}></Button>
                    <Button icon="plus" width={150} text="İşlem Ekle" type={'success'} style={{ fontSize: "15px" }}
                        onClick={openSgkIslemEklePopupForm}></Button>
                </div>
            </div>

            <DataGrid
                className="sgkIslemleriGrid"
                ref={ref => dataGrid = ref}
                style={{ padding: 5 }}
                width="100%"
                //height="100%"
                dataSource={store}
                key="id"
                keyExpr="id"
                showBorders={true}
                focusedRowEnabled={true}
                allowColumnResizing={true}
                columnResizingMode={"widget"}
                //defaultFocusedRowIndex={0}
                columnAutoWidth={false}
                repaintChangesOnly={true}
                //columnHidingEnabled={true}
                //onToolbarPreparing={onToolbarPreparing}
                //selection={{mode: 'multiple', deferred:true}}
                remoteOperations={true}
            >
                <FilterRow visible={true} />
                <ColumnChooser enabled={true} title={"Kolon Seç"} emptyPanelText={"Buraya Sürükleyiniz..."} />
                <Paging defaultPageSize={12} />
                <Pager showPageSizeSelector={true} allowedPageSizes={[12, 24, 36, 48, 60, 100, 200]} showInfo={true} visible={true} />
                <Selection mode="multiple" selectAllMode="page" showCheckBoxesMode="onClick" deferred={false} />

                <Column type="buttons" caption={'İşlem'} width={40}
                    buttons={[
                        {
                            hint: 'Sil', icon: 'trash',
                            visible: () => { return formYetki.sil },
                            onClick: (e) => {
                                kayitSil(e.row.data);
                            }
                        },
                        {
                            hint: 'Tekrar çalış', icon: 'refresh',
                            visible: () => { return formYetki.tekrarCalis },
                            onClick: (e) => {
                                tekrarCalis(e.row.data);
                            }
                        }
                    ]}
                />

                <Column dataField={'id'} width={90} caption={'Id'} dataType="number" visible={false} allowEditing={false} />
                <Column dataField={'domain.name'} width={450} caption={'Firma'} dataType="string" visible={true} allowEditing={false} />
                <Column dataField="donem.donem" width={80} caption={'Dönem'} dataType="string" visible={true} allowEditing={false} />
                <Column dataField="tesvikIslemTuru.adi" width={120} caption={'İşlem'} dataType="string" visible={true} allowEditing={false} />
                <Column dataField="durum" width={110} caption={'Durumu'} allowSorting={false} cellRender={dataIslemDurumuRender} />
                <Column dataField="islemDurumu" width={110} allowSorting={false} cellRender={islemDurumuRender} />
                <Column dataField="baslatmaTarihi" width={120} caption={'Başlama Zamanı'} dataType="date" format="yyyy-MM-dd HH:mm" visible={true} allowEditing={false} />
                <Column dataField={'denemeSayisi'} width={60} caption={'Deneme Sayı'} dataType="int" visible={true} allowEditing={false} />
                <Column dataField="baslangicTarihi" width={60} caption={'İşlem Başlama Saati'} dataType="date" format="HH:mm:ss" visible={true} allowEditing={false} />
                <Column dataField="bitisTarihi" width={60} caption={'İşlem Bitiş Saati'} dataType="date" format="HH:mm:ss" visible={true} allowEditing={false} />

                <Column dataField={'sira'} width={60} caption={'Sıra'} dataType="int" visible={false} allowEditing={false} />
                <Column dataField="baslangicTarihi" width={120} caption={'İşlem Başlama Zamanı'} dataType="date" format="yyyy-MM-dd HH:mm:ss" visible={false} allowEditing={false} />
                <Column dataField="bitisTarihi" width={120} caption={'İşlem Bitiş Zamanı'} dataType="date" format="yyyy-MM-dd HH:mm:ss" visible={false} allowEditing={false} />
                <Column dataField={'createUser.username'} width={60} caption={'Ekleyen Kullanıcı'} dataType="string" visible={true} allowEditing={false} />
                <Column dataField={'hata'} width={60} caption={'Hata'} dataType="string" visible={true} allowEditing={false} />


            </DataGrid>

            <Popup
                visible={sgkIslemEklePopupForm.popupState}
                onHiding={hideSgkIslemEklePopupForm}
                dragEnabled={false}
                closeOnOutsideClick={false}
                //showTitle={true}
                title="   Sgk işlem Ekleme Formu"
                width={900}
                height={760}
            >
                <div>
                    {sgkIslemEklePopupForm.popupState ? <SgkIslemEkleForm hide={hideSgkIslemEklePopupForm} /> : null}
                    <Button
                        width={1000}
                        text="Kapat"
                        type="danger"
                        stylingMode="contained"
                        onClick={hideSgkIslemEklePopupForm}
                    />
                </div>
            </Popup>

        </React.Fragment>
    );
}

export default SgkIslemleri;
